<template>
  <div>
    All open problems, these are not specific for the selected period
    <v-data-table
      :loading="queryLoading"
      :headers="headers"
      :items="items"
      hide-default-footer
      disable-pagination
      multi-sort
    />
  </div>
</template>
<script>
import Component from "vue-class-component";
import ReportBase from "../ReportBase";
import { DETAILS } from "../queries.graphql";
import {
  childRefEnum,
  parentHeader
} from "@/view/content/ServiceManagementReport/constants";
import { CATEGORY_FILTERS_ENUM } from "@/core/constants";

@Component
class OpenProblems extends ReportBase {
  queryLoading = false;
  items = [];
  headers = [
    { text: "Call", value: "caseNumber" },
    { text: "Subject", value: "shortDescription" },
    { text: "Priority", value: "priority" }
  ];

  async parseAndRetrieveData({ accountNumberFilter }) {
    const settings = {
      query: {
        variables: {
          filters: {
            accountNumber: accountNumberFilter,
            state: this.openProblemFilter,
            category: { value: [CATEGORY_FILTERS_ENUM.PROBLEM] }
          }
        },
        query: DETAILS,
        path: "reports.serviceManagementReport.details.result"
      }
    };
    this.queryLoading = true;

    let items = await this.queryData(settings.query);
    this.items = this.setLevel({ data: items, levelName: "priority" });

    this.dataLoaded(childRefEnum.OPEN_PROBLEMS, parentHeader.OPEN_PROBLEMS);
    this.queryLoading = false;
  }
}
export default OpenProblems;
</script>
